(() => {
  const init = () => {
    document.querySelectorAll('[data-printlits-product-section]').forEach(root => {
      const opener = root.querySelector('[data-pl-photo-open]');
      const dialog = root.querySelector('[data-pl-photo-dialog]');
      const main = root.querySelector('.pl-main-media');
      if (!opener || !dialog || !main || opener.dataset.photoReady) return;
      opener.dataset.photoReady = 'true';
      const image = dialog.querySelector('[data-pl-photo-image]');
      const stage = dialog.querySelector('[data-pl-photo-stage]');
      const label = dialog.querySelector('[data-pl-photo-scale]');
      const plus = dialog.querySelector('[data-pl-photo-zoom-in]');
      const minus = dialog.querySelector('[data-pl-photo-zoom-out]');
      let scale = 1, baseWidth = 0, baseHeight = 0, pinchDistance = 0, pinchScale = 1;
      let priorOverflow = '', scrollWasLocked = false;
      const zoom = value => {
        const old = scale;
        const centerX = (stage.scrollLeft + stage.clientWidth / 2) / old;
        const centerY = (stage.scrollTop + stage.clientHeight / 2) / old;
        scale = Math.max(1, Math.min(4, value));
        image.style.width = baseWidth * scale + 'px';
        image.style.height = baseHeight * scale + 'px';
        stage.scrollLeft = Math.max(0, centerX * scale - stage.clientWidth / 2);
        stage.scrollTop = Math.max(0, centerY * scale - stage.clientHeight / 2);
        label.textContent = Math.round(scale * 100) + '%';
        minus.disabled = scale <= 1;
        plus.disabled = scale >= 4;
      };
      const fit = () => {
        const ratio = (image.naturalWidth || main.naturalWidth || 1400) / (image.naturalHeight || main.naturalHeight || 1400);
        baseWidth = Math.max(1, Math.min(stage.clientWidth - 24, (stage.clientHeight - 24) * ratio));
        baseHeight = baseWidth / ratio;
        scale = 1;
        zoom(1);
      };
      opener.addEventListener('click', () => {
        image.alt = main.alt;
        image.src = main.currentSrc || main.src;
        dialog.showModal();
        priorOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        scrollWasLocked = true;
        fit();
      });
      image.addEventListener('load', () => { if (dialog.open) { const requestedScale = scale; fit(); zoom(requestedScale); } });
      plus.addEventListener('click', () => zoom(scale + .5));
      minus.addEventListener('click', () => zoom(scale - .5));
      image.addEventListener('dblclick', () => zoom(scale > 1 ? 1 : 2));
      dialog.querySelector('[data-pl-photo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        if (scrollWasLocked) document.documentElement.style.overflow = priorOverflow;
        scrollWasLocked = false;
        opener.focus({ preventScroll: true });
      });
      const distance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
      stage.addEventListener('touchstart', event => {
        if (event.touches.length !== 2) return;
        event.preventDefault();
        pinchDistance = distance(event.touches);
        pinchScale = scale;
      }, { passive: false });
      stage.addEventListener('touchmove', event => {
        if (event.touches.length !== 2 || !pinchDistance) return;
        event.preventDefault();
        zoom(pinchScale * distance(event.touches) / pinchDistance);
      }, { passive: false });
      stage.addEventListener('touchend', () => { pinchDistance = 0; });
      window.addEventListener('resize', () => { if (dialog.open) fit(); });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
